/**
 * IncidentsList — Etapa 6 (P1-2: Fila de Incidentes operacional).
 *
 * Seção "Incidentes" do menu lateral. Lista apenas devices com problema
 * relevante, ordenados por severidade (ver incidentRules.js). Mostra os
 * top-5 com "Ver todos" para expandir. Cada item é clicável → foca o
 * device (o MapView decide painel/sheet e troca de modo se preciso).
 */
import { useState } from "react";
import { buildIncidents } from "./incidentRules.js";

function hhmm(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return null;
  }
}

const TOP = 5;

export default function IncidentsList({ devices, onSelect }) {
  const [expanded, setExpanded] = useState(false);
  const all = buildIncidents(devices);
  const shown = expanded ? all : all.slice(0, TOP);

  return (
    <div className="ipwd-side-section">
      <div className="ipwd-side-section-head">
        <span>Incidentes</span>
        {all.length > 0 && <span className="ipwd-side-badge">{all.length}</span>}
      </div>

      {all.length === 0 ? (
        <div className="ipwd-side-empty">Sem incidentes ativos.</div>
      ) : (
        <div className="ipwd-incidents">
          {shown.map((it) => {
            const time = hhmm(it.last_seen);
            return (
              <button
                key={it.device_id}
                type="button"
                className="ipwd-incident"
                onClick={() => onSelect?.(it.device_id)}
                title={`Focar ${it.device_id}`}
              >
                <span className="ipwd-incident-dot" style={{ background: it.color }} />
                <span className="ipwd-incident-main">
                  <span className="ipwd-incident-id">{it.device_id}</span>
                  <span className="ipwd-incident-sub">
                    <span style={{ color: it.color }}>{it.reason}</span>
                    {it.customer && <span className="ipwd-incident-cust"> · {it.customer}</span>}
                  </span>
                </span>
                <span className="ipwd-incident-meta">
                  {time && <span className="ipwd-incident-time">{time}</span>}
                  {it.score != null && (
                    <span className="ipwd-incident-score">{it.score}</span>
                  )}
                </span>
              </button>
            );
          })}

          {all.length > TOP && (
            <button
              type="button"
              className="ipwd-incident-toggle"
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded
                ? "Mostrar menos"
                : `Ver todos (${all.length})`}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
